module.exports = __webpack_public_path__ + "static/img/card4.e534f080.png";